var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLossOrTheft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "56px",
    height: "56px",
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "currentColor",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CLY_IconFamily_v2-copy",
    transform: "translate(-510.000000, -461.000000)",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("line", {
    x1: 513.4256,
    y1: 510.9069,
    x2: 562.3166,
    y2: 510.9069,
    id: "Stroke-109"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 510.6175,
    y1: 515.5866,
    x2: 565.1245,
    y2: 515.5866,
    id: "Stroke-110"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 517.6683,
    y1: 511.1193,
    x2: 517.6683,
    y2: 485.0363,
    id: "Stroke-111"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 524.6639,
    y1: 511.1193,
    x2: 524.6639,
    y2: 485.0363,
    id: "Stroke-112"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 551.0784,
    y1: 511.1193,
    x2: 551.0784,
    y2: 485.0363,
    id: "Stroke-113"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 558.0745,
    y1: 511.1193,
    x2: 558.0745,
    y2: 485.0363,
    id: "Stroke-114"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.2606,505.9147 L530.2606,494.3927 C530.2606,490.4147 533.4846,487.1907 537.4626,487.1907 C541.4396,487.1907 544.6636,490.4147 544.6636,494.3927 L544.6636,505.9147",
    id: "Stroke-115"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-116",
    strokeLinejoin: "round",
    points: "537.8338 462.2111 512.3598 478.9611 563.4628 478.9611"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLossOrTheft);
export default __webpack_public_path__ + "static/media/loss-or-theft.a5ae67b409e7500eda73a1f97f93b3cf.svg";
export { ForwardRef as ReactComponent };